export const addresses = {
  store: "0xBa1AC981134Ee7511f072D0C1Fa4800256450b8f",
  provider: "0x8C6527911acc052793ABAbA77eAaCF801fde2F0f",
  token: "0xF30258D294743Dda2A8ce6bdf7677637D3C4bF32",
};
